<markant-platform-modal-bridge>
  <markant-dialog
    [open]="isDialogOpen"
    (close)="closeDialog()"
    class="edit-suborganizations-role-assignment-dialog"
  >
    <div class="content-wrapper">
      <h2>
        {{
          (groupName
            ? 'cartridge.roles.editSuborganizations.titleWithName'
            : 'cartridge.roles.editSuborganizations.title'
          ) | transloco: { name: groupName }
        }}
      </h2>
      <h5>
        {{ 'cartridge.roles.editSuborganizations.info' | transloco }}
      </h5>

      <div class="suborganization-assignments-container">
        <div class="suborganization-assignments-list-container">
          <h5>
            {{ editRoleSuborganizationAssignments.role.localizedServiceName }}
            {{ 'cartridge.roles.editSuborganizations.locations' | transloco }}
          </h5>
          <div class="markant-card-container" markantPlatformScrollIndicator>
            <markant-platform-ui-cartridge-roles-edit-suborganizations
              [variantName]="
                editRoleSuborganizationAssignments.role.localizedServiceName
                  | defaultValue
              "
              [role]="editRoleSuborganizationAssignments.role"
              [suborganizations$]="selectableSuborganizations$"
              [flow]="EditSuborganizationsRoleAssignmentFlow.Add"
              [shouldEnableOverallResponsibility]="
                shouldEnableOverallResponsibilityForAdding
              "
              (suborganizationAdded)="addSuborganization($event)"
              (overallResponsibilityAdded)="
                onDeleteAllSuborganizationAssignmentsClick()
              "
            ></markant-platform-ui-cartridge-roles-edit-suborganizations>
          </div>
        </div>

        <div class="suborganization-assignments-list-container">
          <div class="suborganization-assignments-subtitle">
            <h5>
              {{ editRoleSuborganizationAssignments.role.localizedServiceName }}
              {{
                'cartridge.roles.editSuborganizations.assignedLocations'
                  | transloco
              }}
            </h5>

            @if (selectedSuborganizations.length) {
              <markant-icon
                class="delete-icon"
                icon="m_delete-small"
                (click)="onDeleteAllSuborganizationAssignmentsClick()"
                (keydown.enter)="onDeleteAllSuborganizationAssignmentsClick()"
              >
              </markant-icon>
            }
          </div>
          <div class="markant-card-container" markantPlatformScrollIndicator>
            <markant-platform-ui-cartridge-roles-edit-suborganizations
              [variantName]="
                editRoleSuborganizationAssignments.role.localizedServiceName
                  | defaultValue
              "
              [role]="editRoleSuborganizationAssignments.role"
              [suborganizations$]="selectedSuborganizations$"
              [flow]="EditSuborganizationsRoleAssignmentFlow.Preview"
              [shouldEnableOverallResponsibility]="true"
              (suborganizationRemoved)="removeSuborganization($event)"
            ></markant-platform-ui-cartridge-roles-edit-suborganizations>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="button-wrapper flex-row-end">
      <markant-button
        data-cy="close-dialog-button"
        colorScheme="primary"
        variant="clear"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button
        data-cy="submit-button"
        colorScheme="primary"
        (click)="onSubmit()"
        (keydown.enter)="onSubmit()"
      >
        {{
          'cartridge.roles.editSuborganizations.confirmSelection' | transloco
        }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
